import { ShieldCheck, Wrench, Award, Users, HeartHandshake, Zap } from "lucide-react";

const values = [
  { i: ShieldCheck, t: "Genuine Products", d: "100% authorized dealer stock across every brand we sell." },
  { i: Wrench, t: "Expert Technicians", d: "In-house certified engineers with 10+ years of field experience." },
  { i: Award, t: "Premium After-Sales", d: "Fast turnaround on service tickets and warranty claims." },
  { i: Users, t: "Business Partnerships", d: "Trusted by 1200+ SMEs, offices and retail businesses across Delhi NCR." },
  { i: HeartHandshake, t: "Honest Pricing", d: "Transparent quotations. No hidden charges. Ever." },
  { i: Zap, t: "Rapid Response", d: "Same-day dispatch, next-hour service in most metropolitan zones." },
];

export default function About() {
  return (
    <div>
      <section className="relative overflow-hidden bg-slate-950 text-white py-24">
        <img src="https://images.unsplash.com/photo-1497215842964-222b430dc094?auto=format&fit=crop&w=2000&q=80" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 hero-overlay"></div>
        <div className="relative max-w-4xl mx-auto text-center px-4">
          <div className="text-sm uppercase tracking-widest text-blue-300 font-semibold mb-3">About SSB Copier</div>
          <h1 className="font-heading text-4xl sm:text-6xl font-bold leading-tight text-balance">Technology, delivered with trust.</h1>
          <p className="mt-6 text-slate-200 leading-relaxed max-w-2xl mx-auto">
            For over 15 years, SSB Copier has been Delhi NCR's dependable partner for CCTV surveillance, computing infrastructure, and professional printer services — for households, retailers, and enterprises.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-sm uppercase tracking-widest text-blue-700 font-semibold mb-2">Our Story</div>
            <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900">Built on relationships, not transactions.</h2>
            <div className="mt-6 space-y-4 text-slate-600 leading-relaxed">
              <p>SSB Copier began as a small printer service centre in 2010 with a simple promise — do the job right the first time. Fifteen years later, we've grown into a full-service technology partner spanning surveillance, computing, printing, and enterprise IT.</p>
              <p>Our customers stay with us because we treat their business the way we'd treat our own. When something breaks, we pick up the phone. When something new launches, we test it before we sell it.</p>
              <p>Today we serve 1200+ businesses and thousands of homes with the same core value: <span className="font-semibold text-slate-900">honest technology, delivered on time.</span></p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800" alt="" className="rounded-2xl aspect-[3/4] object-cover" />
            <img src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=800" alt="" className="rounded-2xl aspect-[3/4] object-cover translate-y-8" />
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <div className="text-sm uppercase tracking-widest text-blue-700 font-semibold mb-2">What we stand for</div>
            <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900">The SSB promise</h2>
          </div>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {values.map((v) => (
              <div key={v.t} className="bg-white border border-slate-200 rounded-2xl p-8 shadow-soft">
                <div className="w-11 h-11 grid place-items-center rounded-xl bg-blue-50 text-blue-900 mb-5"><v.i className="w-5 h-5" /></div>
                <h3 className="font-heading font-semibold text-lg text-slate-900 mb-2">{v.t}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
